import { BASE_URL } from '../config'

const REST_ENDPOINTS = {
  RESET_PASSWORD: '/resetPassword',
  FHIR_USER: '/fhirUser',
  EPIC_FHIR_USER: '/epicFhirUser',
  ALTAIS_USER: '/altaisUser'
}

export const resetPasswordEmailOnly = (email) => {
  const URL = BASE_URL + REST_ENDPOINTS.RESET_PASSWORD
  return fetch(URL, {
    method: 'POST',
    headers: {
      authorization: email
    }
  })
}

export const getFhirUser = ({ emrId }) => {
  const URL = BASE_URL + REST_ENDPOINTS.FHIR_USER

  return fetch(URL, {
    method: 'Post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      emrId: emrId
    })
  }).then(res => res.json())
    .catch(err => {
    // TODO: beautify this error message
      alert('Cannot log this user in. User is not registered in the system. Contact support@suki.ai for further assistance.')
      console.error('Error logging in this FHIR User. Contact Support to register the user.', err)
      window.location.href = window.location.origin
    })
}

export const getEpicFhirUser = ({ userInfo }) => {
  const URL = BASE_URL + REST_ENDPOINTS.EPIC_FHIR_USER

  return fetch(URL, {
    method: 'Post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      userInfo: userInfo
    })
  }).then(res => res.json())
    .catch(err => {
    // TODO: beautify this error message
      alert('Cannot log this user in. User is not registered in the system. Contact support@suki.ai for further assistance.')
      console.error('Error logging in this Epic FHIR User. Contact Support to register the user.', err)
      window.location.href = window.location.origin
    })
}
